#import "../../LookupAccountFields.graphql"
mutation LookupAccountCreate($input: LookupAccountCreateInput!) {
  lookupAccountCreate(input: $input) {
    lookupAccount {
      ...LookupAccountFields
    }
  }
}
